import { render, staticRenderFns } from "./BeverageTypes.vue?vue&type=template&id=61dfecb9&scoped=true&"
import script from "./BeverageTypes.vue?vue&type=script&lang=js&"
export * from "./BeverageTypes.vue?vue&type=script&lang=js&"
import style0 from "./BeverageTypes.vue?vue&type=style&index=0&id=61dfecb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dfecb9",
  null
  
)

export default component.exports